/**
 * This file contains logic relevant to sorting projects.
 */
const tinysort = require("tinysort");

/**
 * Sort the project list.
 */
function updateListSorting() {
  const sortingMap = {
    titleEnglish: {attr: 'data-title-english'},
    languageName: {attr: 'data-language-name'},
    scope: {selector: '.sort-scope'},
    country: {selector: '.sort-country'}
  }
  const sortOption = String($(this).val());
  const [sort, order] = sortOption.split(',');
  tinysort($('.products-list>li'), {...sortingMap[sort], order})
}

/**
 * Handle initializing Sort Selector.
 */
export function initSortSelector() {
  $('#id-select').on('change', updateListSorting)
}
